import { useQuery } from '@tanstack/react-query';
import { ApiService } from '../API/AxiosInstance';

// const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData'))?.sub_id : ''
export const useNotificationCount  = (userId) => {
  console.log("countuserId ",userId)
  return useQuery({
    queryKey: ['notification-count', userId],
    enabled: !!userId,
    queryFn: async () => {
      const res = await ApiService().get(
        `${process.env.REACT_APP_BASE_URL}users/${userId}/notifications/count`
      );
       return res?.data?.count;
    },
    staleTime: 1 * 60 * 1000, // 1 minute
    retry: 0,
  });
};


export const useNotifications = ({ subId, page, limit }) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["notifications", subId, page, limit],
    queryFn: async () => {
      const response = await ApiService().get(
        `users/${subId}/notifications?page=${page}&limit=${limit}`
      );
      if (response?.status === 200) {
        return response.data;
      }
      console.log("Failed to fetch notifications");
    },
    enabled: !!subId,
    keepPreviousData: true,
  });

  return {
    notifications: data?.notifications ?? [],
    hasMore: data?.pagination?.hasMore ?? false,
    isLoading,
    isError,
    refetch, // ✅ call this after archive / status change
  };
};